import pinia from '@/plugins/index'
import Vue from 'vue'
import Directive from '@/directives'
// import xss from 'xss'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import '@/styles/styles.scss'

// Vue.prototype.xss = xss
// https://github.com/leizongmin/js-xss/issues/232 使用该方案目前会过滤所有样式，暂不处理xss攻击

Vue.use(Directive)

Vue.config.productionTip = false

const app = new Vue({
  router,
  pinia,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')

export default app
